export default Object.freeze({
  ADD: 'ADD',
  MATCH: 'MATCH',
  MISMATCH: 'MISMATCH',
  MISSING: 'MISSING',
});
